import React, { useState, useMemo } from 'react';

import AutoLink from "Components/AutoLink";
import DialogPortal from "Components/DialogPortal";
import ChannelTalkViewer from "./Popup/ChannelTalkViewer";


const ChannelTalk = ({ message, attach, headerData }) => {
  const [showDetail, setOpenDetail] = useState(false);

  const domImage = useMemo(()=>{
    let image;
    for (let i = 0; i < attach.content.length; i++) {
      if (attach.content[i].type  !== '1') {
        continue;
      }
      image = attach.content[i];
      break;
    }
    if (!image) {
      return null;
    }

    return (
      <figure className="crop">
        <img src={`${process.env.REACT_APP_FILE_API_URL}?type=1&serverfile=${image.imgName}`} alt={image.imgName} />
      </figure>
    );

  },[attach.content]);
  
  return (
    
    <>
      <div className="cont">
        <div className="txt">
          <div className="data">
            <AutoLink text={(message + ' ...더보기') || ' ...더보기'} />
            {domImage}
          </div>
          <button type="button" className="detailView" onClick={setOpenDetail.bind(null, true)}>상세보기</button>
        </div>
      </div>
      {
        showDetail ?
          <DialogPortal>
            <ChannelTalkViewer attach={attach} headerData={headerData} callback={setOpenDetail.bind(null, false)} />
          </DialogPortal> : null
      }
    </>
  )
}

export default React.memo(ChannelTalk);